import Api from "~/core/helper/apiHelper";


export function getContextBySeriesIdAsync({ seriesId }) {
  return Api.asyncGet(`context/${seriesId}`);
}
